import { GameObject, getCanvas, imageAssets, Sprite, SpriteSheet } from "kontra";

const itemsProperties = {
  comet: { frames: `0..${30 + Math.floor(Math.random() * 10)}`, size: 26, speed: 10 },
  stars1: { frames: ['0..7', 7, 7, 7, 7, 7, '7..0', 0, 0, 0, 0, 0, 0], size: 7, speed: 15 },
  stars2: { frames: ['0..6', 6, 6], size: 9, speed: 12 },
}

export class SpaceItem extends GameObject {
  item: Sprite;

  constructor(type) {
    super();

    let spriteSheet = SpriteSheet({
      image: imageAssets[type],
      frameWidth: itemsProperties[type].size,
      frameHeight: itemsProperties[type].size,
      animations: {
        shine: {
          frames: itemsProperties[type].frames,
          frameRate: itemsProperties[type].speed + Math.floor(Math.random() * 5)
        }
      }
    });

    this.item = Sprite({
      x: Math.random() * getCanvas().width,
      y: Math.random() * getCanvas().height,

      // use the sprite sheet animations for the sprite
      animations: spriteSheet.animations
    });

    this.children.push(this.item)
  }
}